import { useState } from 'react';
import { toast } from 'sonner@2.0.3';

import { useAccountStore } from '../../../entities/account';
import { accountsApi } from '../../../shared/api/accounts.api';
import {
  INSTAGRAM_REDIRECT_URI, InstagramLoginClosed, instagramLoginCode, STAFF_SCOPES,
} from '../../account-add/lib/instagramLogin';

/**
 * Переподключение Instagram-аккаунта: новый вход в окне → новый токен на ту же
 * запись. Один путь для пункта меню и кнопки на протухшей карточке.
 */
export function useReconnectInstagram(accountId: string, onSuccess?: () => void) {
  const [loading, setLoading] = useState(false);
  const updateAccount = useAccountStore((state) => state.updateAccount);

  const reconnect = async () => {
    setLoading(true);
    try {
      const code = await instagramLoginCode(STAFF_SCOPES);
      const response = await accountsApi.refreshTokenViaOAuth(accountId, { code, redirectUri: INSTAGRAM_REDIRECT_URI });
      updateAccount(accountId, response.account);
      toast.success('Аккаунт переподключён');
      onSuccess?.();
    } catch (err) {
      if (!(err instanceof InstagramLoginClosed)) {
        toast.error(err instanceof Error ? err.message : 'Не удалось переподключить аккаунт');
      }
    } finally {
      setLoading(false);
    }
  };

  return { reconnect, loading };
}
